import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 sm:py-16 px-4 relative overflow-hidden bg-white" data-id="element-73">
      <div className="max-w-xl mx-auto text-center relative z-10" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-75">
          <CTAButton href="https://suiza.kitonline.shop/cart/44668477210759:1" className="w-full mb-5" data-id="element-76">
            💪 JA! ICH WILL MEINEN UNTERRICHT JETZT REVOLUTIONIEREN
          </CTAButton>

          <div className="flex justify-center gap-3 text-brand-navy font-bold text-xs sm:text-sm" data-id="element-77">
            <span data-id="element-78">⚡ Sofortiger Zugang</span>
            <span data-id="element-79">•</span>
            <span data-id="element-80">🛡️ 7-Tage-Garantie</span>
          </div>
        </motion.div>
      </div>
    </section>;
}